const removeTime = (date = new Date()) => {
  return new Date(date.toDateString());
};

export default removeTime;
